import { useSelector } from 'react-redux';
import { getCurrentAccount } from '../../store/selectors/accountSelectors';
import { accountTypes, accountTypeKeys } from '../enum/api/accountTypes';
import { accountCountryTypes } from '../enum/api/accountCountryTypes';
import { parseEnumType } from '../helpers/enumMappers';

const useSellFromHomeEligibility = () => {
  const account = useSelector(getCurrentAccount);

  const isNonUS = account?.Country === accountCountryTypes.NonUS;
  const isBasicAccount =
    parseEnumType(accountTypeKeys, account?.AccountType) === accountTypes.Basic;

  return { isNonUS, isBasicAccount };
};

export default useSellFromHomeEligibility;
